//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HeightAndAgePercentileOfInfants',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: ''
      },
      dataList1: [
        { name: '男', value: '0' },
        { name: '女', value: '1' }
      ],
      dataList2: [
        { name: '0月', value: '0' },
        { name: '1月', value: '1' },
        { name: '2月', value: '2' },
        { name: '3月', value: '3' },
        { name: '4月', value: '4' },
        { name: '5月', value: '5' },
        { name: '6月', value: '6' },
        { name: '7月', value: '7' },
        { name: '8月', value: '8' },
        { name: '9月', value: '9' },
        { name: '10月', value: '10' },
        { name: '11月', value: '11' },
        { name: '1岁', value: '12' },
        { name: '1岁1月', value: '13' },
        { name: '1岁2月', value: '14' },
        { name: '1岁3月', value: '15' },
        { name: '1岁4月', value: '16' },
        { name: '1岁5月', value: '17' },
        { name: '1岁6月', value: '18' },
        { name: '1岁7月', value: '19' },
        { name: '1岁8月', value: '20' },
        { name: '1岁9月', value: '21' },
        { name: '1岁10月', value: '22' },
        { name: '1岁11月', value: '23' },
        { name: '2岁', value: '24' },
        { name: '2岁3月', value: '25' },
        { name: '2岁6月', value: '26' },
        { name: '2岁9月', value: '27' },
        { name: '3岁', value: '28' }
      ],
      comparisontable0: [{ 'p3': 47.6, 'p25': 49.9, 'p75': 52.5, 'p97': 54.8 }, { 'p3': 51.3, 'p25': 53.8, 'p75': 56.5, 'p97': 59 }, { 'p3': 54.9, 'p25': 57.5, 'p75': 60.4, 'p97': 63 }, { 'p3': 58, 'p25': 60.7, 'p75': 63.7, 'p97': 66.4 }, { 'p3': 60.5, 'p25': 63.3, 'p75': 66.4, 'p97': 69.1 }, { 'p3': 62.5, 'p25': 65.4, 'p75': 68.5, 'p97': 71.3 }, { 'p3': 64.2, 'p25': 67.1, 'p75': 70.3, 'p97': 73.2 }, { 'p3': 65.7, 'p25': 68.7, 'p75': 71.9, 'p97': 74.9 }, { 'p3': 67.1, 'p25': 70.1, 'p75': 73.4, 'p97': 76.4 }, { 'p3': 68.3, 'p25': 71.4, 'p75': 74.7, 'p97': 77.8 }, { 'p3': 69.5, 'p25': 72.6, 'p75': 76, 'p97': 79.1 }, { 'p3': 70.7, 'p25': 73.8, 'p75': 77.3, 'p97': 80.4 }, { 'p3': 71.7, 'p25': 74.9, 'p75': 78.5, 'p97': 81.6 }, { 'p3': 72.8, 'p25': 76, 'p75': 79.6, 'p97': 82.8 }, { 'p3': 73.8, 'p25': 77.1, 'p75': 80.7, 'p97': 84 }, { 'p3': 74.8, 'p25': 78.1, 'p75': 81.8, 'p97': 85.1 }, { 'p3': 75.8, 'p25': 79.2, 'p75': 82.9, 'p97': 86.3 }, { 'p3': 76.8, 'p25': 80.2, 'p75': 84, 'p97': 87.4 }, { 'p3': 77.7, 'p25': 81.2, 'p75': 85, 'p97': 88.5 }, { 'p3': 78.6, 'p25': 82.1, 'p75': 86.1, 'p97': 89.6 }, { 'p3': 79.6, 'p25': 83.1, 'p75': 87.1, 'p97': 90.6 }, { 'p3': 80.5, 'p25': 84.1, 'p75': 88.1, 'p97': 91.7 }, { 'p3': 81.4, 'p25': 85, 'p75': 89.1, 'p97': 92.7 }, { 'p3': 82.2, 'p25': 85.9, 'p75': 90, 'p97': 93.7 }, { 'p3': 82.4, 'p25': 86.1, 'p75': 90.3, 'p97': 94 }, { 'p3': 84.8, 'p25': 88.6, 'p75': 93, 'p97': 96.8 }, { 'p3': 87, 'p25': 91, 'p75': 95.4, 'p97': 99.4 }, { 'p3': 89, 'p25': 93.1, 'p75': 97.7, 'p97': 101.8 }, { 'p3': 90.9, 'p25': 95.1, 'p75': 99.9, 'p97': 104.1 }],
      comparisontable1: [ { p3: 46.8, p25: 49.1, p75: 51.6, p97: 53.8 }, { p3: 50.4, p25: 52.8, p75: 55.4, p97: 57.8 }, { p3: 53.8, p25: 56.3, p75: 59.1, p97: 61.6 }, { p3: 56.7, p25: 59.3, p75: 62.2, p97: 64.8 }, { p3: 59.1, p25: 61.7, p75: 64.8, p97: 67.4 }, { p3: 61.0, p25: 63.8, p75: 66.9, p97: 69.6 }, { p3: 62.7, p25: 65.5, p75: 68.7, p97: 71.5 }, { p3: 64.2, p25: 67.1, p75: 70.3, p97: 73.1 }, { p3: 65.6, p25: 68.5, p75: 71.7, p97: 74.7 }, { p3: 66.8, p25: 69.8, p75: 73.1, p97: 76.1 }, { p3: 68.1, p25: 71.1, p75: 74.5, p97: 77.5 }, { p3: 69.2, p25: 72.3, p75: 75.7, p97: 78.8 }, { p3: 70.4, p25: 73.5, p75: 77.0, p97: 80.1 }, { p3: 71.4, p25: 74.6, p75: 78.2, p97: 81.4 }, { p3: 72.5, p25: 75.7, p75: 79.3, p97: 82.6 }, { p3: 73.5, p25: 76.8, p75: 80.5, p97: 83.8 }, { p3: 74.6, p25: 77.9, p75: 81.6, p97: 84.9 }, { p3: 75.5, p25: 78.9, p75: 82 - 7, p97: 86.1 }, { p3: 76.5, p25: 79.9, p75: 83.8, p97: 87.2 }, { p3: 77.5, p25: 80.9, p75: 84.8, p97: 88.3 }, { p3: 78.4, p25: 81.9, p75: 85.9, p97: 89.4 }, { p3: 79.3, p25: 82.9, p75: 86.9, p97: 90.4 }, { p3: 80.2, p25: 83.8, p75: 87.9, p97: 91.5 }, { p3: 81.1, p25: 84.7, p75: 88.8, p97: 92.5 }, { p3: 81.2, p25: 84.9, p75: 89.1, p97: 92.8 }, { p3: 83.6, p25: 87.4, p75: 91.7, p97: 95.5 }, { p3: 85.7, p25: 89.7, p75: 94.1, p97: 98.1 }, { p3: 87.7, p25: 91.8, p75: 96.4, p97: 100.5 }, { p3: 89.7, p25: 93.9, p75: 98.5, p97: 102.7 } ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.comparisontable0.length, 777)
      let form = JSON.parse(JSON.stringify(self.form))
      if (form.data3 > 150 || form.data3 < 10) return
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        return ''
      }
      let result = form.data3
      console.log(form, 666)
      const comparisontable = self['comparisontable' + form.data1][form.data2]
      console.log(comparisontable, 888)
      if (result <= comparisontable.p3) {
        self.descTxt = '评价等级:下(P3)'
      } else if (result >= comparisontable.p3 && result < comparisontable.p25) {
        self.descTxt = '评价等级:中下(P3-P25)'
      } else if (result >= comparisontable.p25 && result < comparisontable.p75) {
        self.descTxt = '评价等级:中(P25-P75)'
      } else if (result >= comparisontable.p75 && result < comparisontable.p97) {
        self.descTxt = '评价等级:中上(P75-P97)'
      } else if (result >= comparisontable.p97) {
        self.descTxt = '评价等级:上(P97)'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/HeightAndAgePercentileOfInfants.vue